var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_cof.js
// module id = 116
// module chunks = 0